import type { IconNode } from '../types';

/**
 * @name ufo
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggOGMwIDEtMyAyLTYgMlM2IDkgNiA4YTYgNiAwIDAgMSAxMiAwIiAvPgogIDxwYXRoIGQ9Ik03IDEzaC4wMSIgLz4KICA8cGF0aCBkPSJNMTIgMTRoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xNyAxM2guMDEiIC8+CiAgPHBhdGggZD0iTTYgOC4xYy0yLjQgMS00IDIuNi00IDQuNCAwIDMgNC41IDUuNSAxMCA1LjVzMTAtMi41IDEwLTUuNWMwLTEuOC0xLjYtMy40LTQtNC40IiAvPgogIDxwYXRoIGQ9Im03IDIyIDItNCIgLz4KICA8cGF0aCBkPSJtMTcgMjItMi00IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/ufo
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ufo: IconNode = [
  ['path', { d: 'M18 8c0 1-3 2-6 2S6 9 6 8a6 6 0 0 1 12 0', key: 'pf8440' }],
  ['path', { d: 'M7 13h.01', key: '1vezk1' }],
  ['path', { d: 'M12 14h.01', key: '1etili' }],
  ['path', { d: 'M17 13h.01', key: '1yajvo' }],
  [
    'path',
    {
      d: 'M6 8.1c-2.4 1-4 2.6-4 4.4 0 3 4.5 5.5 10 5.5s10-2.5 10-5.5c0-1.8-1.6-3.4-4-4.4',
      key: 'oa3gjz',
    },
  ],
  ['path', { d: 'm7 22 2-4', key: '15gxtx' }],
  ['path', { d: 'm17 22-2-4', key: 'jtqkzb' }],
];

export default ufo;
